



































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { GetterTypes, ActionTypes } from '@/modules/neovehicle/store/types';
import { BrandContract, FamilySegmentsReport, LastClassifications } from '@/modules/neovehicle/models/family';
import { CountryEnum } from '@/models/Enums';
import { GET_COUNTRY_SELECTED } from '@/store/root';
import moment from 'moment';
import { VehicleTypeInitials } from '@/modules/neovehicle/models/enums';

@Component
export default class extends Vue {
  @Getter(GetterTypes.GET_LAST_CLASSIFICATIONS)
  public lastClassifications: LastClassifications;

  @Action(ActionTypes.FETCH_LAST_CLASSIFICATIONS)
  public getLastClassifications: (country: CountryEnum) => Promise<boolean>;

  @Getter(GET_COUNTRY_SELECTED)
  public countrySelected!: CountryEnum;

  public loading = true;
  public data: any = [];
  public keyBrands: any = [];
  public headers = [
    {text: 'C. Modelo Sistema', value: 'idModel', width: 100},
    {text: 'Data Cadastro Modelo', value: 'modelCreatedAt'},
    {text: 'Tipo de Veículo Anfir', value: 'vehicleTypeOriginRange'},
    {text: 'Tipo de Veículo Neocom', value: 'vehicleTypeName'},
    {text: 'C. Bandeira', value: 'idBrand', width: 100},
    {text: 'Bandeira', value: 'brandName'},
    {text: 'Data Referência Valor', value: 'marketValueReference'},
    {text: 'Valor Mercado', value: 'marketValue'},
    {text: 'C. Modelo Anfir', value: 'idOrigin', width: 100},
    {text: 'Modelo', value: 'modelName', width: 200},
    {text: 'C. Versão', value: 'idFamilyVersion', width: 100},
    {text: 'Versão', value: 'familyVersionName'},
    {text: 'C. Família', value: 'idFamily', width: 100},
    {text: 'Família', value: 'familyName'},
    {text: 'C. Família Grupo', value: 'idFamilyGroup', width: 100},
    {text: 'Família Grupo', value: 'familyGroupName'},
    {text: 'Tag Família', value: 'familyTag'},
  ];

  public pagination = {
    sortBy: 'idModel',
    descending: false,
  };

  public async created() {
    this.loading = true;
    await this.getLastClassifications(this.countrySelected);

    this.lastClassifications.brandContracts.map((x: BrandContract) => {
      const brandValue =  `${x.brandName.toLowerCase()}|${x.idVehicleTypes[0]}`;
      this.headers.push({text: `${x.brandName} (${VehicleTypeInitials[x.idVehicleTypes[0]]})`, value: brandValue});
      this.keyBrands.push(brandValue);
    });

    this.data = this.lastClassifications.familySegmentsReport.map((x: FamilySegmentsReport) => {
      const brands = Object.keys(x.brandSegments).reduce((acc: any, bs: any) => {
        acc[bs.toLowerCase()] = x.brandSegments[bs];
        return acc;
      }, {});

      x.modelCreatedAt = moment(x.modelCreatedAt).format('DD/MM/YYYY');

      const result = {...x, ...brands};
      delete result.brandSegments;

      return result;
    });

    this.loading = false;
  }

  public changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }
}
